import React, { useRef, useState,useEffect } from "react";
import AllChatbot from "../../All_Chatbot/AllChatbot";
import SubmitUpdate from "../Updates/SubmitUpdate";
import FactCheck from "../Updates/FactCheck";
import { IconButton } from "@mui/material";
import { useDispatch } from "react-redux";
import {
    fetchCommunityByCommunityId,
    updateCommunityApi,
} from "../../../Services/Community/CommunityAPI/communityApi";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { decryptId } from "../../../Utils/Crypto";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import { HomeOwner } from "../../../Utils/Constant";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";

const Rules = ({ communityName, comData }) => {
    const dispatch = useDispatch();
    const userType = localStorage.getItem("user_type");
    const userId = localStorage.getItem("user_id");
    const { encryptedId } = useParams();
    const id = decryptId(encryptedId);
    const [rulesContentEditable, setRulesContentEditable] = useState(false);
    const [newKey, setNewKey] = useState("");
    const [newValue, setNewValue] = useState("");
    const [comRules, setComRules] = useState(comData?.community_rule);
    const contentRef = useRef(null);
    const [newRules, setNewRules] = useState({})

    useEffect(() => {
        if (comData?.community_rule) {
            setComRules(comData.community_rule);
        }
    }, [comData]);

    const handleRulesUpdate = async (rulesupdate) => {
        try {
            const formDataToSubmit = new FormData();
            formDataToSubmit.append("community_rule", JSON.stringify(rulesupdate));

            await dispatch(
                updateCommunityApi({
                    communityId: id,
                    formData: formDataToSubmit,
                })
            );

            toast.success("Community Rules and Regulations Updated Successfully");
            setComRules(rulesupdate);
            setNewRules({});
            dispatch(fetchCommunityByCommunityId(id));
        } catch (error) {
            toast.error("Failed to update rules & regulations");
            console.error("Update Error:", error);
        } finally {
            setRulesContentEditable(false);
        }
    };

    const handleDelete = (key) => {
        toast(
            <div className="text-center">
                <p className="mb-2">Are you sure you want to delete "{key}"?</p>
                <div className="d-flex justify-content-center gap-2">
                    <button
                        onClick={() => {
                            setComRules((prevRules) => {
                                const updatedRules = { ...prevRules };
                                delete updatedRules[key];
                                return { ...updatedRules }; // Force state update
                            });
                            toast.dismiss();
                        }}
                        className="btn btn-danger btn-sm"
                    >
                        Yes
                    </button>
                    <button
                        onClick={() => toast.dismiss()}
                        className="btn btn-secondary btn-sm"
                    >
                        No
                    </button>
                </div>
            </div>,
            {
                position: "top-center",
                autoClose: false,
                className: "custom-toast",
                closeButton: false,
            }
        );
    };

    // Handle adding a new rule
    const handleAddRule = () => {
        if (newKey.trim() === "" || newValue.trim() === "") {
            alert("Both key and value are required!");
            return;
        }
        setNewRules((prevRules) => ({
            ...prevRules,
            [newKey]: newValue,
        }));
        // setComRules((prevRules) => ({
        //     ...prevRules,
        //     ...newRules
        // }));
        setNewKey("");
        setNewValue("");
    };

    const handleInputRulesChange = (key, value) => {
        setComRules((prevRules) => ({
            ...prevRules,
            [key]: value,
        }));
    };

    return (
        <div className="tab-content">
            <div className="d-flex justify-content-between align-items-center heading-buttons-block margin-bottom-rules">
                <div className="tab-titles">Rules and Regulations</div>
                {userId != null && comData?.owned_by === userId ? (
                    rulesContentEditable ? (
                        <div className="update-btn-action-group">
                            <button
                                className="btn-update-done"
                                onClick={() => handleRulesUpdate({...comRules, ...newRules})}
                            >
                                <DoneIcon />
                            </button>{" "}
                            <button
                                className="btn-update-close"
                                onClick={() => {setRulesContentEditable(false); 
                                    setNewRules({})
                                    }}
                            >
                                <CloseIcon />
                            </button>
                        </div>
                    ) : (
                        <button
                            className="btn-outline-orange"
                            onClick={() => {
                                setRulesContentEditable(true);
                                setTimeout(() => {
                                    if (contentRef.current) {
                                        contentRef.current.focus();
                                    }
                                }, 0);
                            }}
                        >
                            Update Rules & Regulations
                        </button>
                    )
                ) : userId == null || userType === HomeOwner ? (
                    <div className="tab-btns-block d-flex">
                        <SubmitUpdate comData={comData} />
                        <FactCheck />
                    </div>
                ) : (
                    <></>
                )}
            </div>
            {(comData?.community_rule && Object.keys(comData?.community_rule).length !== 0) &&
                (comData?.is_verified ? (
                    <div className="rules-status d-flex gap-3 align-items-center my-4">
                        <div className="icons-rules">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                                width="40"
                                height="40"
                            >
                                <g>
                                    <path
                                        fill="#4caf50"
                                        d="M512 58.668C512 26.305 485.695 0 453.332 0H58.668C26.305 0 0 26.305 0 58.668v394.664C0 485.695 26.305 512 58.668 512h394.664C485.695 512 512 485.695 512 453.332z"
                                    />
                                    <path
                                        fill="#fafafa"
                                        d="M385.75 171.586c8.34 8.34 8.34 21.82 0 30.164L247.082 340.414c-4.16 4.16-9.621 6.254-15.082 6.254s-10.922-2.094-15.082-6.254l-69.332-69.332c-8.344-8.34-8.344-21.824 0-30.164 8.34-8.344 21.82-8.344 30.164 0l54.25 54.25 123.586-123.582c8.34-8.344 21.82-8.344 30.164 0z"
                                    />
                                </g>
                            </svg>
                        </div>
                        <div className="rules-text">
                            <div>
                                <span className="fw-semibold ai-gen-title">
                                    VERIFIED
                                    <Tooltip
                                        title="This community has been verified with association
governing documents for accuracy. If you feel there is a discrepancy,
please use the Fact Check to report the issue."
                                        arrow
                                    >
                                        <div className="svg-info-block">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                fill="currentColor"
                                            >
                                                <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 7H13V9H11V7ZM11 11H13V17H11V11Z"></path>
                                            </svg>
                                        </div>{" "}
                                    </Tooltip>
                                </span>{" "}
                                <p className="m-0">
                                    This community has been verified with association governing
                                    documents for accuracy.
                                </p>
                            </div>
                            <span className="d-block">
                                If you feel there is a discrepancy, please use the Fact Check to
                                report the issue.
                            </span>
                        </div>
                    </div>
                ) : (
                    <div className="rules-status d-flex gap-3 align-items-center my-4">
                        <div className="icons-rules">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 128 128"
                                width="50"
                                height="50"
                            >
                                <g>
                                    <path
                                        d="M49.7 43.72l-12 37.44A1.39 1.39 0 0 0 39 83h3.36a1.39 1.39 0 0 0 1.33-1l1.88-6H62l-.23-.37L63.83 82a1.39 1.39 0 0 0 1.33 1h3.36a1.39 1.39 0 0 0 1.33-1.82l-12-37.44a1.4 1.4 0 0 0-1.33-1H51a1.39 1.39 0 0 0-1.3.98ZM47.57 70l6.19-19.27L60 70Z"
                                        fill="#01889F"
                                    />
                                    <rect
                                        width="6"
                                        height="40.24"
                                        x="79"
                                        y="42.75"
                                        rx="1.4"
                                        fill="#01889F"
                                    />
                                    <path
                                        d="M67.26 98h-29.1A8.16 8.16 0 0 1 30 89.84V38.16A8.16 8.16 0 0 1 38.16 30h51.68A8.16 8.16 0 0 1 98 38.16V64a2.07 2.07 0 0 0 2.12 2 11 11 0 0 1 4.91 1.14 2.06 2.06 0 0 0 3-1.87V38.16A18.16 18.16 0 0 0 89.84 20H38.16A18.16 18.16 0 0 0 20 38.16v51.68A18.16 18.16 0 0 0 38.16 108h33.3a2.07 2.07 0 0 0 1.47-3.53 16.13 16.13 0 0 1-3.71-5.06A2.11 2.11 0 0 0 67.26 98Z"
                                        fill="#01889F"
                                    />
                                    <path
                                        d="M111.73 101.8l9.06-3.57a1 1 0 0 0 0-1.86l-9.06-3.57a12.61 12.61 0 0 1-7.09-7.09l-3.57-9a1 1 0 0 0-.93-.63 1 1 0 0 0-.93.63l-3.57 9a12.58 12.58 0 0 1-7.09 7.09l-9 3.57a1 1 0 0 0 0 1.86l9 3.57a12.58 12.58 0 0 1 7.09 7.09l3.57 9a1 1 0 0 0 .93.64 1 1 0 0 0 .93-.64l3.57-9a12.61 12.61 0 0 1 7.09-7.09Z"
                                        fill="#01889F"
                                    />
                                </g>
                            </svg>
                        </div>
                        <div className="rules-text">
                            <div>
                                <span className="fw-semibold ai-gen-title">
                                    AI GENERATED
                                    <Tooltip
                                        title="This community was generated using proprietary
technology and is awaiting association governing documents.
To contribute, use Submit Update to share community documents."
                                        arrow
                                    >
                                        <div className="svg-info-block">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                fill="currentColor"
                                            >
                                                <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 7H13V9H11V7ZM11 11H13V17H11V11Z"></path>
                                            </svg>
                                        </div>{" "}
                                    </Tooltip>
                                </span>{" "}
                                <p className="m-0">
                                    This community was generated using proprietary technology and
                                    is awaiting association governing documents.
                                </p>
                            </div>
                            <span className="d-block">
                                To contribute, use Submit Update to share community documents.
                            </span>
                        </div>
                    </div>
                ))}
            {Object.entries({ ...comRules, ...newRules }).map(([key, value]) => (
                <div key={key} className="mb-2">
                    <div className="d-flex items-center justify-between">
                        <p style={{ fontWeight: "bolder" }}>{key}:</p>
                        {rulesContentEditable && (
                            <IconButton
                                aria-label="delete"
                                size="small"
                                onClick={() => handleDelete(key)}
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        )}
                    </div>

                    {rulesContentEditable ? (
                        <div
                            contentEditable
                            suppressContentEditableWarning
                            className="border p-2 rounded bg-white"
                            onBlur={(e) => handleInputRulesChange(key, e.target.innerText)}
                        >
                            {value}
                        </div>
                    ) : (
                        <p>{value}</p> // Display non-editable value when not in edit mode
                    )}
                </div>
            ))}
            {rulesContentEditable && (
                <div className="mt-4 p-4 rounded shadow">
                    <h5 className="font-bold">Add New Rule</h5>
                    <div className="d-flex flex-column gap-4">
                        <input
                            type="text"
                            placeholder="Heading"
                            value={newKey}
                            onChange={(e) => setNewKey(e.target.value)}
                            className="border p-2 rounded w-full mt-2"
                        />
                        <input
                            type="text"
                            placeholder="Description"
                            value={newValue}
                            onChange={(e) => setNewValue(e.target.value)}
                            className="border p-2 rounded w-full mt-2"
                        />
                        <button onClick={handleAddRule} className="bttn-upload">
                            Add Rule
                        </button>
                    </div>
                </div>
            )}
            <AllChatbot communitName={communityName} />
        </div>
    );
};

export default Rules;
